// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file market.proto (package cryptotrader, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file market.proto.
 */
export const file_market: GenFile = /*@__PURE__*/
  fileDesc("CgxtYXJrZXQucHJvdG8SDGNyeXB0b3RyYWRlciJPCgxNYXJrZXRTeW1ib2wSDAoEbmFtZRgBIAEoCRIXCg9iYXNlX2Fzc2V0X25hbWUYAiABKAkSGAoQcXVvdGVfYXNzZXRfbmFtZRgDIAEoCSI+Cg9TeW1ib2xzUmVzcG9uc2USKwoHc3ltYm9scxgBIAMoCzIaLmNyeXB0b3RyYWRlci5NYXJrZXRTeW1ib2wiKAoSVGltZWZyYW1lc1Jlc3BvbnNlEhIKCnRpbWVmcmFtZXMYASADKAlCR1pFY29kZWJlcmcub3JnL0NyeXB0b1RyYWRlci9hcHAvcHJvdG8vZ2VuL2NyeXB0b3RyYWRlcnBiO2NyeXB0b3RyYWRlcnBiYgZwcm90bzM");

/**
 * @generated from message cryptotrader.MarketSymbol
 */
export type MarketSymbol = Message<"cryptotrader.MarketSymbol"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string base_asset_name = 2;
   */
  baseAssetName: string;

  /**
   * @generated from field: string quote_asset_name = 3;
   */
  quoteAssetName: string;
};

/**
 * Describes the message cryptotrader.MarketSymbol.
 * Use `create(MarketSymbolSchema)` to create a new message.
 */
export const MarketSymbolSchema: GenMessage<MarketSymbol> = /*@__PURE__*/
  messageDesc(file_market, 0);

/**
 * @generated from message cryptotrader.SymbolsResponse
 */
export type SymbolsResponse = Message<"cryptotrader.SymbolsResponse"> & {
  /**
   * @generated from field: repeated cryptotrader.MarketSymbol symbols = 1;
   */
  symbols: MarketSymbol[];
};

/**
 * Describes the message cryptotrader.SymbolsResponse.
 * Use `create(SymbolsResponseSchema)` to create a new message.
 */
export const SymbolsResponseSchema: GenMessage<SymbolsResponse> = /*@__PURE__*/
  messageDesc(file_market, 1);

/**
 * @generated from message cryptotrader.TimeframesResponse
 */
export type TimeframesResponse = Message<"cryptotrader.TimeframesResponse"> & {
  /**
   * @generated from field: repeated string timeframes = 1;
   */
  timeframes: string[];
};

/**
 * Describes the message cryptotrader.TimeframesResponse.
 * Use `create(TimeframesResponseSchema)` to create a new message.
 */
export const TimeframesResponseSchema: GenMessage<TimeframesResponse> = /*@__PURE__*/
  messageDesc(file_market, 2);

